import { render, staticRenderFns } from "./IconErrorMessage.vue?vue&type=template&id=2b854c7a&"
import script from "./IconErrorMessage.vue?vue&type=script&lang=js&"
export * from "./IconErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./IconErrorMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports